import styles from "./StepRenderer.module.scss";
import { CopyIcon, InfoIcon, LinkIcon } from "../assets/icons";
import type { StepContent } from "../types";
import React from "react";

interface StepRendererProps {
  block: StepContent;
  index?: number;
  resolveBlockValue?: (block: StepContent) => string;
  onCopy?: (value: string) => void;
}

export const StepRenderer: React.FC<StepRendererProps> = ({
  block,
  index,
  resolveBlockValue,
  onCopy,
}) => {
  if (block.type === "CopyField") {
    const value = resolveBlockValue?.(block) || "";
    return (
      <div
        className={`${styles.stepWrap} ${styles.copyField}`}
        onClick={() => onCopy?.(value)}
      >
        <span className={styles.copyValue}>{value}</span>
        <div className={styles.iconWrap}>
          <CopyIcon className={styles.icon} />
        </div>
      </div>
    );
  }
  if (block.type === "LinkField") {
    const value = resolveBlockValue?.(block) || "";
    return (
      <div
        className={`${styles.stepWrap} ${styles.copyField}`}
        onClick={() => {
          if (value) {
            window.open(value, "_blank");
          }
        }}
      >
        <span className={styles.copyValue}>{value}</span>
        <div className={styles.iconWrap}>
          <LinkIcon className={styles.icon} />
        </div>
      </div>
    );
  }

  if (block.type === "Text" || block.type === "NoIconText") {
    return (
      <div className={styles.stepWrap}>
        <p className={styles.stepText}>{block.value}</p>
        {block.type === "Text" && index === 0 && (
          <div className={styles.iconWrap}>
            <InfoIcon className={styles.icon} />
          </div>
        )}
      </div>
    );
  }

  return null;
};
